module.exports = __webpack_public_path__ + "img/house7.927641f7.png";